export const translation = {
  navigateToPaymentMethods: 'Scegli di pagare in un altro modo',
  payWithCard: 'Paga con una carta',
  cardNumber: 'Numero di carta',
  cardExpiry: 'Data di scadenza (MM/AA)',
  cardExpiryPlaceholder: 'MM/AA',
  cardCVV: 'CVV',
  cardholderName: 'Titolare della carta',
  cardholderNamePlaceholder: 'Nome e cognome',
  digits: 'cifre',
  previouslyUsed: 'Precedentemente utilizzato:',
  forgetPaymentMethods: 'Elimina i metodi di pagamento',
  forgetSavedCard: 'Elimina la carta che termina con {{last4Digits}}',
  required: 'Obbligatorio',
  invalid: 'Non valido',
  cardInvalid: 'Il numero della carta non è valido',
  expiryInvalid: 'La data di scadenza non è valida',
  expiryMonthInvalid: 'Il mese della data di scadenza non è valido',
  expiryYearInvalid: "L'anno della data di scadenza non è valido",
  cardExpired: 'La carta è scaduta',
  cardIncomplete: 'Il numero della carta è incompleto',
  expiryIncomplete: 'La data di scadenza è incompleta',
  cvvIncomplete: 'Il numero CVV è incompleto',
  cvvInvalid3: 'Il CVV deve essere di 3 cifre',
  cvvInvalid4: 'Il CVV deve essere di 4 cifre',
  cardRequired: 'Il numero della carta è obbligatorio',
  expiryRequired: 'La data di scadenza è obbligatoria',
  cvvRequired: 'Numero CVV obbligatorio',
  cardNameRequired: 'Il nome sulla carta è obbligatorio',
  forgetPayPal: "Elimina l'account PayPal",
  savePaymentMethod: 'Salva metodo di pagamento',
  managePaymentMethods: 'Gestisci i tuoi metodi di pagamento',
  savedPaymentMethodsEmpty:
    'Inserisci i dati della tua carta di seguito per aggiungere un nuovo metodo di pagamento',
  newPaymentMethod: 'Aggiungi un nuovo metodo di pagamento',
  cardEndingWith: 'Carta che termina con',
  otherWaysToPay: 'Altri modi per pagare',
  pay: 'Paga',
  addCard: 'Aggiungi carta',
  // Payment methods dropdown
  editPaymentMethods: 'Modifica i metodi di pagamento salvati',
  confirmCardDeletion: 'Confermare - Elimina carta',
  confirmPayPalDeletion: 'Confermare - Elimina PayPal',
  delete: 'Elimina',
  cancel: 'Annulla',
  // Direct Debit Form
  accountHolder: 'Titolare del Conto',
  address: 'Indirizzo',
  addressLine1: 'Indirizzo linea 1',
  addressLine2: 'Indirizzo linea 2',
  fullName: 'Come e Cognome',
  email: 'E-mail',
  city: 'Città',
  postalCode: 'Codice Postale',
  setUpDirectDebit: 'Impostare Direct Debit',
  unsupportedCardType: 'Tipo di carta non supportato',
  // Success scene
  checkSuccessTitle: 'Il tuo pagamento è andato a buon fine!',
  // Error
  tokenizationError:
    'Impossibile elaborare il pagamento. Prova con un altro metodo di pagamento.',
  duplicatePaymentMethodError: 'Questo metodo di pagamento è già salvato.',
  // Payment Method Popup Overlay
  paymentMethodPopupOverlayClose: 'Cerca',
  paymentMethodPopupOverlayDescription:
    'Hai problemi a visualizzare la pagina di pagamento {{paymentMethodName}}? Ti aiuteremo a trovarlo!',
  paymentMethodPopupOverlayBringBackThePaymentPage:
    'Mostra la pagina di pagamento',
};
